import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

import { GmailService } from '../../../services/gmail.service';
import { O365Service } from '../../../services/o365.service';
import { ErrorService } from '../../../services/error.service';
import { GlobalMessageService } from '../../../services/global-message.service';
import { DriftService } from '../../../services/drift.service';

@Component({
  selector: 'app-bot-auth',
  templateUrl: './bot-auth.component.html'
})
export class BotAuthComponent implements OnInit {

  @ViewChild('invalidGoogleDialog') invalidGoogleDialog: ElementRef;
  @ViewChild('duplicateGoogleDialog') duplicateGoogleDialog: ElementRef;
  @ViewChild('duplicateO365Dialog') duplicateO365Dialog: ElementRef;
  @ViewChild('cancelledGoogleDialog') cancelledGoogleDialog: ElementRef;

  invalidGoogleDialogRef: BsModalRef;
  duplicateGoogleDialogRef: BsModalRef;
  duplicateO365DialogRef :BsModalRef;
  cancelledGoogleDialogRef: BsModalRef;

  type: string = '';
  googleEmailAddress: string = '';
  loadingMessage: string = '';

  constructor(private route: ActivatedRoute,
  						private router: Router,
              private gmailService: GmailService,
              private o365Service: O365Service,
              private errorService: ErrorService,
              private driftService: DriftService,
              private modalService: BsModalService,
              private globalMessageService: GlobalMessageService) { }

  ngOnInit() {
    this.type = this.route.snapshot.params['id'];

    if (this.type == 'gmail') {
      this.handleGmailAuth();
    }
    else if(this.type == 'o365'){
      this.handleO365Auth();
    }
  }

  private handleO365Auth(){
    var cancelled = this.route.snapshot.queryParams['error'];
    if (!cancelled) {
      var code = this.route.snapshot.queryParams['code'];
      var state = this.route.snapshot.queryParams['state'];
      if (!code || !state) {
        // TODO: something?
      }
      else {
        // state will contain the email address of the person authenticating
        this.driftService.track('added-inbox', {type: 'o365'});
        var stateObj: any = JSON.parse(decodeURIComponent(state));
        let direct: boolean = stateObj.email=='direct';

        if (direct) {
          this.loadingMessage = 'Saving credentials...';
        }
        else {
          this.loadingMessage = 'Logging you into Drift Email...';
        }

        this.o365Service.grantAccessBot(code, stateObj.email).subscribe(
          (result: any) => {
            if (direct) {
              this.router.navigate(['settings/bot']);
              this.globalMessageService.message('Inbox added successfully');
            }

          },
          error => {
            // Invalid user
            if (error.status == 404) {
              if (direct) {
                this.duplicateO365DialogRef = this.modalService.show(this.duplicateO365Dialog);
                this.router.navigate(['settings/bot']);
              }
              else {
                // currently O365 is only direct (no invites)
              }
            }
            else {
              // some other server error, needs to be logged
              this.globalMessageService.error();
              this.errorService.log(error, 'bot-auth.component', 'onSubmit');
            }
          }
        )
      }
    }
    else {
      // Do-nothing: o365 doesn't have cancel option
    }
  }

  private handleGmailAuth() {
    let cancelled = this.route.snapshot.queryParams['error'];
    if (!cancelled) {
      let code = this.route.snapshot.queryParams['code'];
      let state = this.route.snapshot.queryParams['state'];
      if (!code || !state) {
        // TODO: something?
      }
      else {
        // state will contain the email address of the person authenticating
        let stateObj: any = JSON.parse(decodeURIComponent(state));
        let direct: boolean = stateObj.email=='direct';

        if (direct) {
          this.loadingMessage = 'Saving credentials...';
        }
        else {
          this.loadingMessage = 'Logging you into Drift Email...';
        }

        this.gmailService.grantAccessBot(code, stateObj.email).subscribe(
          (result: any) => {
            this.driftService.track('added-bot', {type: 'gmail'});
            if (direct) {
              this.router.navigate(['settings/bot']);
              this.globalMessageService.message('Bot added successfully');
            }
          },
          error => {
            // Invalid user
            if (error.status == 404) {
              if (direct) {
                this.duplicateGoogleDialogRef = this.modalService.show(this.duplicateGoogleDialog);
                this.modalService.onHide.subscribe(
                  () => {
                    this.router.navigate(['settings/bot']);
                  }
                );
              }
              else {
                this.googleEmailAddress = stateObj.email;
                this.invalidGoogleDialogRef = this.modalService.show(this.invalidGoogleDialog);
                this.modalService.onHide.subscribe(
                  () => {
                    this.router.navigate(['logout']);
                  }
                );
              }
            }
            else {
              // some other server error, needs to be logged
              this.globalMessageService.error();
              this.errorService.log(error, 'bot-auth.component', 'onSubmit');
            }
          }
        )
      }
    }
    else {
      // canceled operation
      this.cancelledGoogleDialogRef = this.modalService.show(this.cancelledGoogleDialog);
      this.modalService.onHide.subscribe(
        () => {
          this.router.navigate(['settings/bot']);
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/settings/settings-bot/bot-auth/bot-auth.component.ts